import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Brand, Product} from '../../../shared/models/models';
import {NGXLogger} from "ngx-logger";

@Component({
  selector: 'app-brand-edit',
  templateUrl: './brand-edit.component.html',
  styleUrls: ['./brand-edit.component.scss']
})

export class BrandEditComponent implements OnInit {
  description!: string;
  dialogTitle!: string;

  /**
   * Constructor
   * @param dialogRef Dialog reference
   * @param data Data passed into dialog
   * @param logger Logger Instance.
   */
  constructor(
    public dialogRef: MatDialogRef<BrandEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {brand: Brand, title: string},
    private logger: NGXLogger) { }

  /**
   * Init
   */
  ngOnInit(): void {
    this.dialogTitle = this.data.title;
    if (this.data.brand != undefined) {
      this.description = this.data.brand.name;
    }
  }

  /**
   * Called when Ok is clicked.
   */
  onOk(): void {
    let brandId = 0;
    if (this.data.brand != undefined) {
      brandId = this.data.brand.id;
    }

    let brand = new Brand(brandId,  this.description, new Array<Product>());
    this.logger.debug("ProductEditComponent-onOk - Closing Product Edit, Product updates:" + JSON.stringify(brand));
    this.dialogRef.close(brand);
  }
}
